import { Slider } from '@massilia/ui'

import { Route } from '@/routes/_booking/flights.results'
import { formatDuration } from '@/utils/format-duration'
import { useFilters } from '@/utils/use-search-params'

import { FilterDrawer } from './filter-drawer'

export interface DurationRange {
  max: number
  min: number
}

interface DurationFilterProps {
  bounds: DurationRange
}

export function DurationFilter({ bounds }: DurationFilterProps) {
  const {
    filters: { filterDurationMax, filterDurationMin },
    setFilters,
  } = useFilters(Route.id)

  return (
    <FilterDrawer title="Durée totale du vol">
      <div className="space-y-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Durée</span>
          <span className="font-medium text-gray-700">
            {formatDuration(filterDurationMin ?? bounds.min)} -{' '}
            {formatDuration(filterDurationMax ?? bounds.max)}
          </span>
        </div>

        <Slider
          max={bounds.max}
          min={bounds.min}
          onValueChange={(values) => {
            setFilters({ filterDurationMax: values[1], filterDurationMin: values[0] })
          }}
          step={30} // 30 minutes steps
          value={[filterDurationMin ?? bounds.min, filterDurationMax ?? bounds.max]}
        />

        <div className="flex justify-between text-xs text-gray-500">
          <span>{formatDuration(bounds.min)}</span>
          <span>{formatDuration(bounds.max)}</span>
        </div>
      </div>
    </FilterDrawer>
  )
}
